<div mat-dialog-title>
  <span>
    <ng-container *ngIf="!(loading$ | async); else titleSpinner">
      {{ title | translate: {name: customView.name} }}
    </ng-container>
    <ng-template #titleSpinner>
      <app-title-spinner></app-title-spinner>
    </ng-template>
  </span>

  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-content-loader [isLoading]="loading$ | async"></q9-content-loader>

<form #form="ngForm" [formGroup]="formGroup">
  <mat-dialog-content>
    <ng-container *ngIf="!(loading$ | async)">
      <div class="edit-sort-content">
        <div class="edit-sort-wrapper">
          <div>
            <q9-select
              [required]="true"
              [label]="'RUBIC_CUBE.SORT_COLUMN_LABEL' | translate"
              [disabled]="!columns.length"
              formControlName="column"
              (selectionChange)="updateSubColumn($event)">
              <q9-option *ngFor="let column of columns" [value]="column.value">
                {{ column.displayValue | translate }}
              </q9-option>
            </q9-select>
          </div>
          <div>
            <q9-select
              [required]="true"
              [label]="'RUBIC_CUBE.SORT_ORDER_LABEL' | translate"
              [disabled]="!chosenType"
              formControlName="direction"
              (selectionChange)="updateSubColumn($event)">
              <q9-option
                *ngFor="let direction of directions[chosenType] || []"
                [value]="direction.value">
                {{ direction.label | translate }}
              </q9-option>
            </q9-select>
          </div>
        </div>
        <q9-info-message *ngIf="error" type="error">{{ error | translate }}</q9-info-message>
      </div>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions class="right-side">
    <q9-secondary-button [color]="'primary'" (click)="closeModal()">
      {{ 'GENERAL.CANCEL_BTN' | translate }}
    </q9-secondary-button>

    <ng-container *ngIf="sortExists">
      <q9-secondary-button
        [color]="'warn'"
        (click)="changeRemove(true); form.onSubmit($event); onSubmit()">
        {{ 'RUBIC_CUBE.REMOVE_SORTING' | translate }}
      </q9-secondary-button>
    </ng-container>

    <q9-primary-button
      [color]="'primary'"
      (click)="changeRemove(false); form.onSubmit($event); onSubmit()">
      {{ 'GENERAL.CONFIRM_BTN' | translate }}
    </q9-primary-button>
  </mat-dialog-actions>
</form>
